import app from '@devices/settings/device_settings/app.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLULiquidLevel',
	friendly_name: 'BLU Liquid Level Sensor ZB',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: false,
			bluetooth_settings: [
				{ title: 'zigbee', component: 'zigbee_ble', min_ver: '1.2.12' },
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
